"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIconContext = exports.IconDirectionContextProvider = exports.createFluentIcon = exports.bundleIcon = exports.wrapIcon = void 0;
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./icons/chunk-0"), exports);
tslib_1.__exportStar(require("./icons/chunk-1"), exports);
tslib_1.__exportStar(require("./icons/chunk-2"), exports);
tslib_1.__exportStar(require("./icons/chunk-3"), exports);
tslib_1.__exportStar(require("./icons/chunk-4"), exports);
tslib_1.__exportStar(require("./icons/chunk-5"), exports);
tslib_1.__exportStar(require("./sizedIcons/chunk-0"), exports);
tslib_1.__exportStar(require("./sizedIcons/chunk-1"), exports);
tslib_1.__exportStar(require("./sizedIcons/chunk-2"), exports);
tslib_1.__exportStar(require("./sizedIcons/chunk-3"), exports);
tslib_1.__exportStar(require("./sizedIcons/chunk-4"), exports);
tslib_1.__exportStar(require("./sizedIcons/chunk-5"), exports);
tslib_1.__exportStar(require("./sizedIcons/chunk-6"), exports);
tslib_1.__exportStar(require("./sizedIcons/chunk-7"), exports);
tslib_1.__exportStar(require("./sizedIcons/chunk-8"), exports);
tslib_1.__exportStar(require("./sizedIcons/chunk-9"), exports);
tslib_1.__exportStar(require("./sizedIcons/chunk-10"), exports);
tslib_1.__exportStar(require("./sizedIcons/chunk-11"), exports);
tslib_1.__exportStar(require("./sizedIcons/chunk-12"), exports);
tslib_1.__exportStar(require("./sizedIcons/chunk-13"), exports);
tslib_1.__exportStar(require("./sizedIcons/chunk-14"), exports);
tslib_1.__exportStar(require("./sizedIcons/chunk-15"), exports);
tslib_1.__exportStar(require("./sizedIcons/chunk-16"), exports);
var wrapIcon_1 = require("./utils/wrapIcon");
Object.defineProperty(exports, "wrapIcon", {
  enumerable: true,
  get: function () {
    return tslib_1.__importDefault(wrapIcon_1).default;
  }
});
var bundleIcon_1 = require("./utils/bundleIcon");
Object.defineProperty(exports, "bundleIcon", {
  enumerable: true,
  get: function () {
    return tslib_1.__importDefault(bundleIcon_1).default;
  }
});
var createFluentIcon_1 = require("./utils/createFluentIcon");
Object.defineProperty(exports, "createFluentIcon", {
  enumerable: true,
  get: function () {
    return createFluentIcon_1.createFluentIcon;
  }
});
tslib_1.__exportStar(require("./utils/useIconState"), exports);
tslib_1.__exportStar(require("./utils/constants"), exports);
var index_1 = require("./contexts/index");
Object.defineProperty(exports, "IconDirectionContextProvider", {
  enumerable: true,
  get: function () {
    return index_1.IconDirectionContextProvider;
  }
});
Object.defineProperty(exports, "useIconContext", {
  enumerable: true,
  get: function () {
    return index_1.useIconContext;
  }
});